import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { RefreshCw, Trash2, Mail, Phone, Building2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/contact`);
      setSubs(data);
    } catch (e) {
      setSubs([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggleStatus = async (s) => {
    const next = s.status === "new" ? "read" : "new";
    await axios.patch(`${API}/contact/${s.id}?status=${next}`);
    load();
  };

  const remove = async (id) => {
    await axios.delete(`${API}/contact/${id}`);
    load();
  };

  const newCount = subs.filter((s) => s.status === "new").length;

  const fmt = (iso) => {
    try { return new Date(iso).toLocaleString(); } catch { return iso; }
  };

  return (
    <div className="mv">
      <div className="admin-wrap" data-testid="admin-page">
        <div className="admin-head">
          <div>
            <h1>Contact Submissions</h1>
            <p style={{ color: "var(--text-muted)", fontSize: "0.9rem", marginTop: 4 }}>Discovery call requests from the website.</p>
          </div>
          <button className="sub-btn" onClick={load} data-testid="admin-refresh"><RefreshCw size={14} style={{ verticalAlign: "-2px", marginRight: 6 }} />Refresh</button>
        </div>

        <div className="admin-stats">
          <div className="admin-stat"><div className="a-num" data-testid="admin-total">{subs.length}</div><div className="a-label">Total Submissions</div></div>
          <div className="admin-stat"><div className="a-num">{newCount}</div><div className="a-label">New / Unread</div></div>
          <div className="admin-stat"><div className="a-num">{subs.length - newCount}</div><div className="a-label">Reviewed</div></div>
        </div>

        {loading ? (
          <div className="admin-empty">Loading…</div>
        ) : subs.length === 0 ? (
          <div className="admin-empty" data-testid="admin-empty">No submissions yet. They'll appear here as soon as someone fills out the contact form.</div>
        ) : (
          subs.map((s) => (
            <div className="sub-card" key={s.id} data-testid="admin-submission">
              <div className="sub-top">
                <div>
                  <h3>{s.name}</h3>
                  <div className="sub-meta">
                    <Building2 size={13} style={{ verticalAlign: "-2px" }} /> {s.company}
                    {s.service ? ` · ${s.service}` : ""} · {fmt(s.created_at)}
                  </div>
                  <div className="sub-meta" style={{ marginTop: 6 }}>
                    <a href={`mailto:${s.email}`} style={{ color: "var(--cyan)" }}><Mail size={13} style={{ verticalAlign: "-2px" }} /> {s.email}</a>
                    {s.phone ? <span> · <Phone size={13} style={{ verticalAlign: "-2px" }} /> {s.phone}</span> : null}
                  </div>
                </div>
                <span className={`sub-badge ${s.status === "new" ? "new" : "read"}`}>{s.status}</span>
              </div>
              {s.challenge ? <div className="sub-challenge">{s.challenge}</div> : null}
              <div className="sub-actions">
                <button className="sub-btn" onClick={() => toggleStatus(s)}>{s.status === "new" ? "Mark as read" : "Mark as new"}</button>
                <button className="sub-btn danger" onClick={() => remove(s.id)}><Trash2 size={13} style={{ verticalAlign: "-2px", marginRight: 4 }} />Delete</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
